import React, { useEffect } from 'react'

const LeadCaptureForm = () => {
    useEffect(() => {
        // Load HubSpot form script
        const script = document.createElement('script')
        script.src = 'https://js.hsforms.net/forms/embed/developer/21994206.js'
        script.defer = true
        document.body.appendChild(script)

        return () => {
            // Cleanup script on unmount
            if (script.parentNode) {
                script.parentNode.removeChild(script)
            }
        }
    }, [])

    return (
        <>
            {/* eslint-disable-next-line react/no-unknown-property */}
            <style jsx global>{`
                .hsfc-Renderer form .hsfc-Step .hsfc-Step__Content {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                    padding-top: 0;
                    padding-bottom: 0;
                    justify-content: center;
                }

                form .hsfc-Step__Content .hsfc-Row {
                    width: 48%;
                }

                .hsfc-Renderer form .hsfc-NavigationRow {
                    width: 100%;
                    margin-top: 0;
                }

                .hsfc-NavigationRow button.hsfc-Button {
                    width: 100%;
                    background: linear-gradient(
                        to right,
                        #ed5c2f,
                        #f28230,
                        #fab331
                    );
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 24px;
                    max-width: fit-content;
                    margin: 0 auto;
                    border-radius: 9px;
                    padding: 17px 18px;
                }

                .hsfc-Step__Content .hsfc-Row input {
                    background: #fff;
                    border: none;
                    border-radius: 12px;
                    padding: 17px 22px;
                }

                .hsfc-Step__Content .hsfc-Row .hsfc-PhoneInput__FlagAndCaret {
                    background: #fff;
                    border: none;
                    border-radius: 12px;
                }

                .hsfc-Step__Content
                    .hsfc-Row
                    .hsfc-PhoneInput__FlagAndCaret:hover {
                    filter: none;
                }
                @media (max-width: 768px) {
                    .hsfc-Renderer form .hsfc-Step .hsfc-Step__Content {
                        padding: 20px 0px;
                    }
                    form .hsfc-Step__Content .hsfc-Row {
                        width: 108%;
                    }
                    .hsfc-NavigationRow button.hsfc-Button {
                        font-size: 14px;
                        line-height: 24px;
                    }
                }
            `}</style>
            <section className="py-16 md:py-20">
                <div className="container mx-auto px-4">
                    <div
                        className="mx-auto bg-[#FFF8EA] p-8 md:p-16"
                        style={{
                            borderTopRightRadius: '100px',
                            borderBottomLeftRadius: '100px',
                        }}>
                        {/* Heading */}
                        <div className="text-center mb-10 md:mb-12">
                            <h2 className="text-2xl md:text-3xl lg:text-3xl font-semibold mb-2">
                                Enter Details To Get Free{' '}
                                <span className="text-orange-500">
                                    Roofing Marketing Report
                                </span>
                            </h2>
                        </div>

                        {/* HubSpot Form */}
                        <div className="hubspot-form-wrapper">
                            <div
                                className="hs-form-html"
                                data-region="na1"
                                data-form-id="93f2edd2-721e-489e-af30-1cb3a5253c4b"
                                data-portal-id="21994206"></div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default LeadCaptureForm
